import { render } from "./ComplianceClaimsComponent.vue?vue&type=template&id=1c33229f&scoped=true"
import script from "./ComplianceClaimsComponent.vue?vue&type=script&lang=js"
export * from "./ComplianceClaimsComponent.vue?vue&type=script&lang=js"

import "./ComplianceClaimsComponent.vue?vue&type=style&index=0&id=1c33229f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c33229f"]])

export default __exports__